import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { id: "app" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MainToolbar = _resolveComponent("MainToolbar")!
  const _component_TrinketGrid = _resolveComponent("TrinketGrid")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_Footer = _resolveComponent("Footer")!
  const _component_SettingsModal = _resolveComponent("SettingsModal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_MainToolbar),
    _createVNode(_component_TrinketGrid),
    _createVNode(_component_Toast, { ref: "toast" }, null, 512),
    _createVNode(_component_Footer),
    _createVNode(_component_SettingsModal)
  ]))
}